import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { boxSizes, colors, fontSizes, fontWeights, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const starsContainerCss = css`
    & .rating-stars .rating-stars-icon {
        color: ${colors.blade};
    }
`

export const ScoreWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${gutterSizes.base};
    padding: ${gutterSizes.large} ${gutterSizes.xxlarge};
    border: 1px solid ${colors.newBorder};
    border-radius: ${boxSizes.borderRadius4};
    width: fit-content;
`;

export const ScoreValue = styled.span`
    font-size: ${fontSizes.xlarge};
    font-weight: ${fontWeights.bold};
    color: ${colors.bark};
`;

export const OutOfText = styled.span`
    color: ${colors.darkGrey};
`;

export const StarsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${gutterSizes.xsmall};
`;

export const StarIcon = styled.div`
    display: flex;
    align-items: center;
    
    svg {
        width: 17px;
        height: 16px;
    }
`;

export const ReviewsCount = styled.span`
    color: ${colors.darkGrey};
    margin-left: auto;
`;
